import AdminAuthApi from 'api/AdminAuthApi';
import EnvironmentApi from 'api/EnvironmentApi';
import GooglePlacesRestApi from 'api/digifi/core/GooglePlacesApi';
import VariablesRestApi from 'api/digifi/core/VariablesApi';
import SettingsRestApi from 'api/digifi/dlp/SettingsApi';
import ApplicationDocumentConfigurationRestApi from 'api/digifi/los/ApplicationDocumentConfigurationApi';
import ApplicationsRestApi from 'api/digifi/los/ApplicationsApi';
import AutomationWorkflowApi from 'api/digifi/los/AutomationWorkflowApi';
import PortalPageElementsRestApi from 'api/digifi/los/PortalPageElementsApi';
import PortalPageInfoRestApi from 'api/digifi/los/PortalPageInfoApi';
import ProductCalculationsRestApi from 'api/digifi/los/ProductCalculationsApi';
import TasksDetailsRestApi from 'api/digifi/los/TaskDetailsApi';
import TasksRestApi from 'api/digifi/los/TasksApi';
import LayoutConfigurationRestApi from 'api/digifi/los/layout/LayoutConfigurationApi';

export const productCalculationsApi = new ProductCalculationsRestApi();
export const googlePlacesApi = new GooglePlacesRestApi();
export const variablesApi = new VariablesRestApi();
export const settingsApi = new SettingsRestApi();
export const layoutConfigurationApi = new LayoutConfigurationRestApi();
export const applicationDocumentConfigurationApi = new ApplicationDocumentConfigurationRestApi();
export const adminAuthApi = new AdminAuthApi();
export const applicationsApi = new ApplicationsRestApi();
export const portalPageElementsApi = new PortalPageElementsRestApi();
export const tasksApi = new TasksRestApi();
export const automationWorkflowApi = new AutomationWorkflowApi();
export const environmentApi = new EnvironmentApi();
export const taskDetailsApi = new TasksDetailsRestApi();
export const portalPageInfoApi = new PortalPageInfoRestApi();
